"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackDisposable = exports.markTracked = exports.disableDisposablesTrack = exports.enableDisposablesTrack = void 0;
var dispose_type_1 = require("./dispose-type");
var TRACK_DISPOSABLES = false;
var isDisposableTracked = '__is_disposable_tracked__';
function enableDisposablesTrack() {
    TRACK_DISPOSABLES = true;
}
exports.enableDisposablesTrack = enableDisposablesTrack;
function disableDisposablesTrack() {
    TRACK_DISPOSABLES = false;
}
exports.disableDisposablesTrack = disableDisposablesTrack;
function markTracked(x) {
    if (!TRACK_DISPOSABLES) {
        return;
    }
    if (x && x !== dispose_type_1.DisposableNone) {
        try {
            x[isDisposableTracked] = true;
        }
        catch (_a) {
            // noop
        }
    }
}
exports.markTracked = markTracked;
function trackDisposable(x) {
    if (!TRACK_DISPOSABLES) {
        return x;
    }
    if (!x[isDisposableTracked]) {
        x[isDisposableTracked] = false;
    }
    // 获取内存泄露堆栈
    var stack = new Error('Potentially leaked disposable').stack;
    setTimeout(function () {
        if (!x[isDisposableTracked]) {
            console.log(stack);
        }
    }, 3000);
    return x;
}
exports.trackDisposable = trackDisposable;
//# sourceMappingURL=dispose-marktrack.js.map